let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jGU8v")).then(() => parcelRequire('91ovr'));